package dev.bitspittle.droidconSf24.pages.sections.kobweb.basics

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import dev.bitspittle.droidconSf24.components.widgets.*
import dev.bitspittle.droidconSf24.components.examples.*
import dev.bitspittle.droidconSf24.utilities.dataId
import dev.bitspittle.droidconSf24.utilities.attr
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.icons.fa.IconStyle as FaIconStyle
import com.varabyte.kobweb.silk.components.icons.mdi.*
import com.varabyte.kobweb.silk.components.icons.mdi.IconStyle as MdiIconStyle
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr

@Page
@Composable
fun ProjectOrganization10Page() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("sections/kobweb/basics/ProjectOrganization10.md", mapOf())) {
        dev.bitspittle.droidconSf24.components.layouts.SectionLayout {
            org.jetbrains.compose.web.dom.H2(attrs = { id("project-organization") }) {
                com.varabyte.kobweb.compose.dom.GenericTag("span", "data-id=\"title\"") {
                    org.jetbrains.compose.web.dom.Text("Project organization")
                }
            }
            Folders(Modifier.fillMaxWidth().padding(left = 5.cssRem).dataId("folders")) {
                org.jetbrains.compose.web.dom.Ul {
                    org.jetbrains.compose.web.dom.Li {
                        org.jetbrains.compose.web.dom.Text("resources/public")
                        org.jetbrains.compose.web.dom.Ul {
                            org.jetbrains.compose.web.dom.Li {
                                org.jetbrains.compose.web.dom.Text("images")
                                org.jetbrains.compose.web.dom.Ul {
                                    org.jetbrains.compose.web.dom.Li {
                                        org.jetbrains.compose.web.dom.Text("buster.jpg")
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Horizontal {
                dev.bitspittle.droidconSf24.components.widgets.Code("""Img(
  src =
   "/images/buster.jpg",
  attrs =
    Modifier.fillMaxSize()
      .toAttrs()
)
""", "kotlin 2-3 <fragment,fade-right> {data-fragment-index=1}")
                Image("buster.jpg", Modifier.classNames("fragment", "fade-left"))
            }
        }
    }
}
